import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authenticationApis } from "../utils/apis";
import { AUTH_BASE_URL, createAxiosInstanceUser } from "../utils/request";
import axios from "axios";
import { getUsers } from "../utils/getUser";

export const registerUser = createAsyncThunk("signup", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceUser();
    const response = await axiosInstance.post(
      authenticationApis.registerUser,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const loginUser = createAsyncThunk("login", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceUser();
    const response = await axiosInstance.post(
      authenticationApis.loginUser,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const getDiscordId = createAsyncThunk(
  "getDiscordId",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        `${authenticationApis.getDiscordId}?discord_id=${payload.discord_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const loginUserByGoogle = createAsyncThunk(
  "loginGoogle",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        authenticationApis.loginByGoogle,
        {
          headers: { "auth-token": payload?.authToken },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const loginUserByApple = createAsyncThunk(
  "loginApple",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        authenticationApis.loginByApple,
        {
          headers: { "auth-token": payload?.authToken },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const verifyEmailByOtp = createAsyncThunk(
  "verifyEmail",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verifyEmail,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const verifyEmailByOtpGiftCard = createAsyncThunk(
  "verifyEmailByOtpGiftCard",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verifyGiftCardEmail,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const forgottonPassword = createAsyncThunk(
  "forgottonPassword",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.forgotPasswordApi,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const enable2FA = createAsyncThunk("enable2FA", async (payload) => {
  try {
    // Open API - no authentication required
    const response = await axios.post(
      `${AUTH_BASE_URL}/${authenticationApis.enable2FA}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.detail || error.message);
  }
});

export const verify2FASetup = createAsyncThunk(
  "verify2FASetup",
  async (payload) => {
    try {
      // Open API - no authentication required
      const response = await axios.post(
        `${AUTH_BASE_URL}/${authenticationApis.verify2FASetup}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
);

export const verify2FALogin = createAsyncThunk(
  "verify2FALogin",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verify2FALogin,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const disable2FA = createAsyncThunk("disable2FA", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceUser();
    const response = await axiosInstance.post(
      authenticationApis.disable2FA,
      payload
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const getPlaidIdentityVerificationStatus = createAsyncThunk(
  "getPlaidIdentityVerificationStatus",
  async () => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        authenticationApis.getPlaidIdentityVerificationStatus
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createPlaidIdentityVerification = createAsyncThunk(
  "createPlaidIdentityVerification",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.createPlaidIdentityVerification,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const retryPlaidIdentityVerification = createAsyncThunk(
  "retryPlaidIdentityVerification",
  async () => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.retryPlaidIdentityVerification
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const manualVerifyPlaidIdentity = createAsyncThunk(
  "manualVerifyPlaidIdentity",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.manualVerifyPlaidIdentity,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const createPlaidBankLinkToken = createAsyncThunk(
  "createPlaidBankLinkToken",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.createPlaidBankLinkToken,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);


export const getPlaidBankVerificationStatus = createAsyncThunk(
  "getPlaidBankVerificationStatus",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        `${authenticationApis.getPlaidBankVerificationStatus}?payment_method_id=${payload.payment_method_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const verifyPlaidBankAccount = createAsyncThunk(
  "verifyPlaidBankAccount",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verifyPlaidBankAccount,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);
export const manualVerifyPlaidBankAccount = createAsyncThunk(
  "manualVerifyPlaidBankAccount",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.manualVerifyPlaidBankAccount,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateProfilePicture = createAsyncThunk(
  "updateProfilePicture",
  async (payload) => {
    const access_token = getUsers()?.access_token;
    try {
      const response = await axios.post(
        `${AUTH_BASE_URL}/${authenticationApis.uploadProfilePicture}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (error) {
      throw Error(error.response.data.detail);
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "updateUserProfile",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.updateProfile,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const resetPassword = createAsyncThunk(
  "resetPassword",
  async ({ payload, access_token }) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.resetPasswordApi,
        payload,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const registerManagers = createAsyncThunk(
  "registerManagers",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.addManagers,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getAllUser = createAsyncThunk("getAllUser", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceUser();
    const response = await axiosInstance.get(authenticationApis.getListAllUser);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const getUserByid = createAsyncThunk("getUserByid", async (payload) => {
  try {
    const axiosInstance = createAxiosInstanceUser();
    const response = await axiosInstance.get(
      `${authenticationApis.getUserByid}?id=${payload.userId}`
    );
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    } else {
      throw new Error(error.response?.data?.detail || error.message);
    }
  }
});

export const verifyInvite = createAsyncThunk(
  "verifyInvite",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verifyManagement,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const sendMobileOtp = createAsyncThunk(
  "sendMobileOtp",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.sendMobileOtp,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const verifyMobileOtp = createAsyncThunk(
  "verifyMobileOtp",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.verifyMobileOtp,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const updateDiscordRole = createAsyncThunk(
  "updateDiscordRole",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.updateDiscordRole,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const addPaymentDetails = createAsyncThunk(
  "addPaymentDetails",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.addPaymentDetails,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const makeDefaultPaymentMethod = createAsyncThunk(
  "addPaymentDetails",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        `${authenticationApis.makeDefaultMethod}?id=${payload.id}`,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const deletePaymentDetails = createAsyncThunk(
  "deletePaymentDetails",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.post(
        authenticationApis.deletePaymentDetails,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const GetBankDetailsByRoutingNumber = createAsyncThunk(
  "getBankDetailsByRoutingNumber",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        `${authenticationApis.GetBankDetailsByRoutingNumber}/${payload.routing_number}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getPaymentdetailsByUserid = createAsyncThunk(
  "getPaymentdetailsByUserid",
  async (payload) => {
    try {
      const axiosInstance = createAxiosInstanceUser();
      const response = await axiosInstance.get(
        authenticationApis.getPaymentDetails
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const autheticationRegisterSlice = createSlice({
  name: "SearchVitals",
  initialState: {
    loginData: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.loginData = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default autheticationRegisterSlice.reducer;

